import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mfp-bg my-mfp-zoom-in mfp-ready" }, null, -1)
const _hoisted_3 = {
  class: "mfp-wrap mfp-auto-cursor my-mfp-zoom-in mfp-ready",
  tabindex: "-1",
  style: {"overflow":"hidden auto"}
}
const _hoisted_4 = { class: "mfp-container mfp-inline-holder" }
const _hoisted_5 = { class: "mfp-container mfp-inline-holder" }
const _hoisted_6 = { class: "mfp-content" }
const _hoisted_7 = {
  id: "modal-dialog",
  class: "downloadAPP"
}
const _hoisted_8 = {
  class: "content",
  id: "sign-in-dialog"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "popup_wrapper" }
const _hoisted_11 = { class: "popup_content" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "wrapper" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurantMessage, (notification) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: notification.id,
                                        class: _normalizeClass(['d-flex', 'align-items-center', 'p-3', 'my-3', 'text-white', notification.type === 'danger' ? 'bg-danger' : notification.type === 'warning' ? 'bg-warning' : notification.type === 'success' ? 'bg-success' : '', 'rounded', 'box-shadow'])
                                      }, _toDisplayString(notification.title) + ": " + _toDisplayString(notification.content), 3))
                                    }), 128)),
                                    _hoisted_15,
                                    _createElementVNode("button", {
                                      type: "submit",
                                      style: {"margin-left":"68px"},
                                      class: "btn_1 mt-2 mb-4",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                                    }, " OK ")
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}